// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CoordinationCardRelevance\ApiCoordinationCardRelevance.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationCardSelf, CoordinationCardSelfData, CoordinationCardSelfOptions } from 'data/models/CoordinationCardSelf';
import { Event, EventData, EventOptions } from 'data/models/Event';

// CoordinationCardRelevanceData is the class that CoordinationCardRelevance serializes to/from
export interface CoordinationCardRelevanceData {
    CoordinationCardId : number;
    EventId : number;
	
    CoordinationCard : CoordinationCardSelfData | null;
    Event : EventData | null;
	
}

// CoordinationCardRelevanceOptions is the class which may be passed to the CoordinationCardRelevance constructor to define optional initial data values
export interface CoordinationCardRelevanceOptions {
    CoordinationCardId : number;
    EventId : number;
	
    CoordinationCard? : CoordinationCardSelfOptions | null;
    Event? : EventOptions | null;
	
}

export class CoordinationCardRelevance {
    public CoordinationCardId : DataSignal<number>;
    public EventId : DataSignal<number>;
	
    public CoordinationCard : DataSignal<CoordinationCardSelf | null>;
    public Event : DataSignal<Event | null>;
	

    constructor();
    constructor(data : CoordinationCardRelevanceOptions);
    constructor(data: CoordinationCardRelevanceOptions | null = null) {
        this.CoordinationCardId = jsonableObservable(S.value<number>(data && data.CoordinationCardId !== undefined ? data.CoordinationCardId : 0));
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
	    
        this.CoordinationCard = S.value<CoordinationCardSelf | null>(null);
        this.Event = S.value<Event | null>(null);
	    
    }

    static key(obj : CoordinationCardRelevance) {
        return obj.CoordinationCardId() + '\u2618' + obj.EventId();
    }
    
    static dataKey(obj : CoordinationCardRelevanceOptions) {
        return obj.CoordinationCardId + '\u2618' + obj.EventId;
    }

    static update(obj : CoordinationCardRelevance, data : CoordinationCardRelevanceOptions) {
        S.freeze(() => {
            if (data.CoordinationCardId !== undefined) obj.CoordinationCardId(data.CoordinationCardId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CoordinationCardRelevance.ts